{
  "name": "payslip-checker",
  "private": true,
  "version": "0.1.0",
  "type": "module",
  "engines": {
    "node": ">=24.21.0 <25"
  },
  "scripts": {
    "dev": "vite",
    "build": "tsc --noEmit && vite build",
    "preview": "vite preview",
    "test": "bash tools/with-lock.sh test vitest run",
    "test:affected": "node --experimental-strip-types --no-warnings=ExperimentalWarning tools/affected-tests.ts",
    "coverage-report": "jiti tools/coverage-report.ts",
    "test:fast": "MAGIA_TEST_SET=fast vitest run",
    "test:slow": "MAGIA_TEST_SET=slow bash tools/with-lock.sh test vitest run",
    "test:upgrade": "MAGIA_SLOW_TESTS=1 vitest run tests/ocr/upgrade.browser.test.ts",
    "quarantine": "node --experimental-strip-types --no-warnings=ExperimentalWarning tools/quarantine.ts",
    "test:watch": "vitest",
    "lint": "eslint .",
    "icon-lint": "node --experimental-strip-types --no-warnings=ExperimentalWarning tools/iconLint.ts",
    "typecheck": "tsc --noEmit",
    "verify": "bash tools/with-lock.sh verify node --experimental-strip-types --no-warnings=ExperimentalWarning tools/verify.ts",
    "audit": "npm audit --omit=dev --audit-level=high",
    "prepare": "git config core.hooksPath .githooks || true",
    "fixtures": "FIXTURES_WRITE=1 vitest run tools/fixtures.test.ts",
    "ocr-fixtures": "OCR_FIXTURES_WRITE=1 vitest run tools/ocr/fixtures.test.ts",
    "photo-proof": "jiti tools/ocr/photo-proof.ts",
    "ocr-benchmark": "OCR_BENCHMARK=1 vitest run tools/ocr/benchmark.test.ts",
    "explanations-review": "REVIEW_WRITE=1 vitest run tools/explanationsReview.test.ts",
    "check-links": "node --experimental-strip-types --no-warnings=ExperimentalWarning tools/check-links.ts",
    "translate": "bash tools/with-lock.sh translate node --experimental-strip-types --no-warnings=ExperimentalWarning tools/translate.ts",
    "translate-health": "node --experimental-strip-types --no-warnings=ExperimentalWarning tools/translate-health.ts",
    "translations-status": "node --experimental-strip-types --no-warnings=ExperimentalWarning tools/translate.ts --status",
    "screenshots": "jiti tools/screenshots.ts",
    "layout-map": "jiti tools/layoutMap.ts",
    "visual:update": "VISUAL_UPDATE=1 bash tools/with-lock.sh ui vitest run tests/ui/visual.browser.test.ts",
    "layout-baseline": "LAYOUT_BASELINE_WRITE=1 vitest run tests/ui/layoutApp.browser.test.ts",
    "doc-report": "jiti tools/doc-report.ts",
    "dead-ends-review": "jiti tools/dead-ends-review.ts",
    "translation-coverage": "TRANSLATION_COVERAGE=1 vitest run tests/local/translationCoverage.test.ts --silent=false",
    "mistake-gallery": "rm -rf \"${TMPDIR:-/tmp}/magia-gallery-results\" && MISTAKE_GALLERY_WRITE=1 vitest run tests/gallery/gallery. && node --experimental-strip-types --no-warnings=ExperimentalWarning tools/gallery/write-doc.ts",
    "private-gate": "bash tools/with-lock.sh private-gate node --experimental-strip-types --no-warnings=ExperimentalWarning tools/private-gate.ts",
    "deploy": "bash tools/with-lock.sh deploy node --experimental-strip-types --no-warnings=ExperimentalWarning tools/deploy-run.ts prod",
    "deploy:preview": "bash tools/with-lock.sh deploy node --experimental-strip-types --no-warnings=ExperimentalWarning tools/deploy-run.ts preview",
    "beta-summary": "node --experimental-strip-types --no-warnings=ExperimentalWarning tools/beta-summary.ts",
    "synthetic-docs": "node --experimental-strip-types --no-warnings=ExperimentalWarning tools/synthetic-docs.ts",
    "skeleton-pdf": "node --experimental-strip-types --no-warnings=ExperimentalWarning tools/skeleton-to-pdf.ts",
    "verify:full": "tsc --noEmit && eslint . && vitest run && npm run translations-status && npm run audit",
    "personas": "PERSONAS_WRITE=1 vitest run tests/personas"
  },
  "devDependencies": {
    "@eslint/js": "^10.0.1",
    "@fontsource/ibm-plex-mono": "^5.3.0",
    "@fontsource/noto-sans-arabic": "^5.3.0",
    "@fontsource/noto-sans-devanagari": "^5.3.0",
    "@fontsource/noto-sans-ethiopic": "^5.3.0",
    "@fontsource/noto-sans-thai": "^5.3.0",
    "@fontsource/rubik": "^5.3.0",
    "@napi-rs/canvas": "1.0.10",
    "@types/node": "^22.20.5",
    "axe-core": "4.13.0",
    "eslint": "^10.12.0",
    "globals": "^17.13.0",
    "jiti": "2.4.2",
    "playwright-core": "1.64.0",
    "sharp": "0.35.5",
    "typescript": "^6.0.3",
    "typescript-eslint": "^8.71.1",
    "vite": "^8.3.4",
    "@vitest/coverage-v8": "5.0.3",
    "vitest": "^5.0.3"
  },
  "dependencies": {
    "@tesseract.js-data/eng": "1.0.0",
    "@tesseract.js-data/heb": "1.0.0",
    "jpeg-js": "0.4.4",
    "pdfjs-dist": "6.4.299",
    "tesseract.js": "7.0.0",
    "uqr": "0.1.3"
  }
}
